/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M20.2264 1.0388A2.3327 2.3327 0 0 0 18.2854 0H5.7123c-.78 0-1.5084.3898-1.941 1.0388L1.333 4.6962 0 20.3342C0 22.3588 1.6413 24 3.6658 24H20.332c2.0246 0 3.6658-1.6412 3.6658-3.6658l-1.333-15.638-2.4383-3.6574Zm-14.5141.9607h12.5731l.0817.0102.0756.0293a.3335.3335 0 0 1 .12.109l1.2342 1.8511H4.199l1.236-1.8512a.3333.3333 0 0 1 .2773-.1483ZM15.9964 8.998c.5521 0 .9998.4476.9998.9997 0 2.7608-2.2381 4.9989-4.9989 4.9989-2.7608 0-4.9989-2.2381-4.9989-4.9989 0-.5521.4476-.9997.9998-.9997s.9998.4476.9998.9997c0 1.6565 1.3428 2.9994 2.9993 2.9994 1.5875 0 2.8869-1.2333 2.9924-2.794l.0069-.2054c0-.5521.4476-.9997.9998-.9997Z"
    clipRule="evenodd"
  />,
  'MenuMarketFilled'
);
